// Hook for the fixed, full-viewport "popover" wrapper shared by the `modal`
// and `footer_banner` components (see core_components.ex). Both wrappers use
// `position: fixed; inset: 0` plus a flex alignment (`items-center` for
// `modal`, `items-end` for `footer_banner`) to place their content - but
// `inset: 0` tracks the layout viewport, which most mobile browsers do NOT
// shrink when the on-screen keyboard opens. That leaves the flex alignment
// computed against the full window height, so the popover either ends up
// with a lot of dead space above it (centered modal) or hidden behind the
// keyboard (bottom banner).
//
// We track `window.visualViewport` (which DOES shrink) and resize/reposition
// the wrapper to match it, so the existing flex alignment naturally keeps
// the popover's content within the visible area - no separate logic needed
// per component.
export const KeyboardAvoidingPopover = {
  mounted() {
    this.updatePosition = this.updatePosition.bind(this);

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", this.updatePosition);
      window.visualViewport.addEventListener("scroll", this.updatePosition);
    }

    this.updatePosition();
  },

  destroyed() {
    if (window.visualViewport) {
      window.visualViewport.removeEventListener("resize", this.updatePosition);
      window.visualViewport.removeEventListener("scroll", this.updatePosition);
    }
  },

  updatePosition() {
    if (!window.visualViewport) return;

    this.el.style.top = `${window.visualViewport.offsetTop}px`;
    this.el.style.height = `${window.visualViewport.height}px`;
  },
};
